/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";

interface CardComponentProps {
    children: React.ReactNode | React.ReactNode[];
    className?: string | boolean;
}

const CardComponent = (props: CardComponentProps) => {
	return (
		<div
			className={clsx(
				props.className && props.className,
				"CardComponent bg-white text-gray-900 p-2 xl:p-3 rounded-[10px] shadow-card dark:bg-gray-950 dark:text-gray-100"
			)}
		>
			{props.children}
		</div>
	);
};

export default CardComponent;
